import * as React from 'react';
import {useState} from "react";
import '../../App.css';
import { useNavigate } from 'react-router-dom';

import { db } from '../../firebase-config.js';
import { doc, updateDoc, serverTimestamp, getDoc } from "firebase/firestore";

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { Box, Grid, Typography, Card,CardContent, IconButton } from '@mui/material';
import { DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

import BorderColorIcon from '@mui/icons-material/BorderColor';

const holidays = ['4/7/2023', '4/21/2023', '5/1/2023', '8/28/2023', '11/27/2023', '12/25/2023', '12/30/2023', '08/21/2023', '11/01/2023', '12/08/2023', '12/31/2023']; 

function getBusinessDays(startDate, endDate, holidays) {
  var seconds = Math.floor((endDate-startDate)/1000);

  var d = Math.floor(seconds / (3600*24));
  var h = Math.floor(seconds % (3600*24) / 3600);
  var m = Math.floor(seconds % 3600 / 60);
  var s = Math.floor(seconds % 60);

  // Count the number of business days (excluding weekends and holidays)
  let businessDays = 0;
  for (let i = 0; i < d; i++) {
    const currentDate = new Date(startDate.getTime() + (i * (24 * 60 * 60 * 1000)));
    const currentDay = currentDate.getDay(); // 0: Sunday, 1: Monday, ..., 6: Saturday
    // Exclude weekends (Saturday: 6, Sunday: 0)
    if (currentDay !== 0 && currentDay !== 6) {
      // Exclude holidays
      const formattedDate = currentDate.toLocaleDateString();
      console.log(formattedDate)
      if (!holidays.includes(formattedDate)) {
        businessDays++;
      }
      else {console.log(formattedDate)}
    }
  }

  return businessDays+" days "+h+":"+m+":"+s;
}


export default function FormDialog(props) {

  const row = props.data

  const email = row.email
  const helptopic = row.helptopic
  const helpdetails = row.helpdetails
  const firstname = row.fname
  const lastname = row.lname
  const ticketid = row.tid

  const [open, setOpen] = React.useState(false);
  const [confirmation, setConfirmation] = useState(false)
  const [TicketStatus, setTicketStatus] = useState(row.stat);

  let navigate = useNavigate();

  const handleConfirm = () => {
    setConfirmation(true);
  }

  const handleReject = () => {
    setConfirmation(false);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.location.reload()
  };

  return (
    <div maxWidth={false} disableGutters className="font-link">
      <Button variant="contained"
              size="small" 
              style={{fontFamily: "Segoe UI"}} 
              sx={row.stat === "Resolved"?{":hover": {bgcolor: "#5A0C0E", color:"white"}, bgcolor:"#223730"}:{":hover": {bgcolor: "#5A0C0E", color:"white"}, bgcolor:"#223730"}} 
              onClick={handleClickOpen}
              startIcon={<BorderColorIcon/>}>
          Respond
      </Button>
      <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { width: "100%"} }}>
        <Box style={{ display:'flex', justifyContent:'center' }}>
            <Grid sx={{mt:1}}>
              <Card sx={{boxShadow:0}} style={{ maxWidth:500, minHeight: 350, padding: "10px 5px", margin: "0 auto"}}>
                <CardContent>
                  <Typography fontWeight="bold" variant="h5" align="center" sx={{ mt: 1, mb:1 }} fontFamily="Segoe UI">
                    RESPONSE FORM
                  </Typography>

                  <Typography align="center" sx={{ mt: 2, mb: 1 }}  color = '#9e9e9e' fontFamily="Segoe UI">
                    TICKET DETAILS - <b>{TicketStatus}</b>
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <TextField label="Name" variant="standard" disabled = 'True' value = {firstname+" "+lastname} fullWidth />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField label="Email" variant="standard" disabled = 'True' value = {email} fullWidth/>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField label="Help Topic" variant="standard" disabled = 'True' value = {helptopic} fullWidth/>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField label="Help Details" multiline variant="standard" disabled = 'True' value = {helpdetails} fullWidth/>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="h6" align="center" sx={{ mt: 3, mb:1 }} fontFamily="Segoe UI">
                      TICKET ACTIONS
                      </Typography>
                      <a href={'mailto:' + email + '?subject=DCS Helpdesk Ticket ID [' + ticketid + '] Thread &body=RE: ' + helptopic +'%0d%0a      "'+ helpdetails +'"'} >
                        <Button type="submit" variant="contained" size="small" style={{fontFamily: "Segoe UI"}} sx={{ mt:1, mb:1, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'}}} fullWidth>
                        SEND EMAIL
                        </Button>
                      </a>
                      <Button type="submit" variant="contained" size="small" style={{fontFamily: "Segoe UI"}} sx={{ mt:1, mb:1, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'}}} fullWidth
                      disabled = {TicketStatus === "Resolved" ? true:false}
                      onClick={handleConfirm}
                      >
                      {row.stat === 'Resolved'? 'REOPEN': 'CLOSE'} TICKET
                      </Button>
                    </Grid>
                  </Grid>
                  <DialogActions>
                    <Button variant="contained" size="medium" style={{fontFamily: "Segoe UI"}} sx={{mt:2, ":hover": {bgcolor: "#5A0C0E", color:"white"}, bgcolor:"#223730"}} onClick={handleClose}>Close</Button>
                  </DialogActions>
                </CardContent>
              </Card>
            </Grid>
          </Box>  
      </Dialog>
      <Dialog open={confirmation} onClose={handleReject} PaperProps={{ sx : { maxWidth: 400} }}>
        <DialogTitle>
          {"Close Ticket?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to close the ticket?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReject} autoFocus type="submit" variant="outlined" size="small" style={{fontFamily: "Segoe UI"}} sx={{ mt:1, mb:1, color: '#666666', ":hover": {color: '#212121'}}}>
            NO, KEEP OPEN
          </Button>
          <Button type="submit" variant="contained" size="small" style={{fontFamily: "Segoe UI"}} sx={{ mt:1, mb:1, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'}}}
          onClick={e => {
            e.preventDefault();
            updateDoc(doc(db, "tickets", ticketid), {status: 'Resolved'});
            updateDoc(doc(db, "tickets", ticketid), {responsetime:getBusinessDays(new Date(row.dt), Date.now(),holidays)});
            setTicketStatus('Resolved');
            handleReject();
          }}>YES, CLOSE TICKET</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}